export enum AUTH_ROUTES {
  API = '/api',
  REPORTS = '/reports',
  REPORTS_CREATE = '/reports/create',

  GROUPS = '/groups',

  DEVICE_BLOCKS = '/device-blocks',
  TAGS_MANAGEMENT = '/tags-management',

  SETTINGS = '/settings',
  SETTINGS_OVERVIEW = '/settings/overview',
  SETTINGS_MY_ACCOUNT = '/settings/my-account',
  SETTINGS_LOGIN_SECURITY = '/settings/login-security',
  SETTINGS_USERS = '/settings/users',
  SETTINGS_AUDIT = '/settings/audit',

  DEVELOPER = '/developer',
  DEVELOPER_SDK = '/developer/sdk',
  DEVELOPER_BATCH = '/developer/batch',
  DEVELOPER_BATCH_CREATE = '/developer/batch/create',
  DEVELOPER_CREDENTIALS = '/developer/credentials',
  DEVELOPER_CREDENTIALS_CREATE = '/developer/credentials/create',

  IMPERSONATE = '/impersonate',
}

export enum PUBLIC_ROUTES {
  LOGIN = '/',
  LOGIN_ALT = '/login',
  FORGOT_PASSWORD = '/forgot-password',
  JOIN_ORGANIZATION = '/join-organization',
  NEW_PASSWORD = '/new-password',
  TWO_FACTOR_SETUP = '/two-factor-setup',
}

export const ALL_ROUTES = {
  ...AUTH_ROUTES,
  ...PUBLIC_ROUTES,
} as const;
